import { render, staticRenderFns } from "./ModalFormCheckbookComponent.vue?vue&type=template&id=735bc180"
import script from "./ModalFormCheckbookComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormCheckbookComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports